import React, { FC, Suspense, useState, } from 'react'
import Modal from 'react-responsive-modal';
import { updateLocationStatus } from '../../models/_location';

type Props = {
    currentLocationId: string;
    changeReactivateModal: boolean
    handleCloseReactivateLocation: () => void;
    refreshTable?: any
}

export const ReactivateLocationModal: FC<Props> = ({
    changeReactivateModal,
    handleCloseReactivateLocation,
    currentLocationId,
    refreshTable
}) => {

    const [locationStatus] = useState(true);
  const handleLocationStatus = async (confirmedToActivateMachines: boolean) => {
    try {
      const recordId = currentLocationId; 
      await updateLocationStatus(recordId, locationStatus,confirmedToActivateMachines);
    } catch (error) {
      console.error('Error updating Location status:', error);
    }
    handleCloseReactivateLocation()
    if(typeof refreshTable !== 'undefined'){
        refreshTable() 
      }
  };
    return (

        <div>
            <Suspense>
                <Modal
                    open={changeReactivateModal}
                    onClose={() => handleCloseReactivateLocation()}
                    role="modal"
                    center
                    classNames={{
                        root: "content-wrapper",
                    }}
                >
                    <div className='modal-title'></div>
                    <div className="modal-body p-2">
                        <h4 className=" fs-4 mb-8">Do you want to reactivate machines as well?</h4>
                    </div>
                    <div className="modal-footer justify-content-center p-2">
                        <button className="btn btn-primary me-4 ml-4 col-3 mt-4"  onClick={() => handleLocationStatus(true)}>Yes</button>
                        <button className="btn btn-secondary col-3 mt-4" onClick={() => handleLocationStatus(false)}>No </button>

                    </div>
                </Modal>
               
            </Suspense>
        </div>
    )
}

export default ReactivateLocationModal
